<!-- 统一用户权限管理 - 角色管理 -->
<template>
    <div>
        <admin-main-header></admin-main-header>

        <div class="admin-main-body">
            <div class="admin-content" :style="{minHeight: adminContentMinHeight + 'px'}">
                <div class="admin-content-title el-clearfix">
                    <span class="el-title-bar"> 全部角色</span>
                </div>
                <div class="admin-content-main">
                    <div class="el-search-form">
                        <el-form ref="roleQueryForm" :model="roleQueryForm">
                            <el-row :gutter="20">
                                <el-col :span="5" :offset="4">
                                    <el-form-item prop="roleName">
                                        <el-input v-model="roleQueryForm.roleName" :maxlength="100" placeholder="角色名称"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                    <el-form-item prop="roleCode">
                                        <el-input v-model="roleQueryForm.roleCode" :maxlength="100" placeholder="角色代码"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                    <el-form-item class="el-align-center">
                                        <el-button @click="resetRoleQueryForm" icon="fas fa-undo">重 置</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
                                        <el-button type="primary" @click="queryRoleList(1000)" icon="fas fa-search">查 询</el-button>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                    <div class="el-search-toolbar">
                        <el-button type="primary" size="small" icon="fas fa-plus-circle" @click="openRoleEditDialog('add')">添加角色</el-button>
                    </div>
                    <div class="el-search-list">
                        <el-table ref="roleTable" v-loading="roleQueryLoading" element-loading-text="拼命加载中..." element-loading-custom-class="el-loading-mask-opacity" :class="{loading: roleQueryLoading}" :data="roleList" :default-sort="roleQuerySort" @sort-change="onRoleQuerySortChange" style="width:100%;" class="el-table-overflow-x-hidden" empty-text="暂无数据">
                            <el-table-column label="#" type="index" width="40"></el-table-column>
                            <el-table-column type="selection" width="60" v-if="currentActionType == 'config'"></el-table-column>
                            <el-table-column label="角色名称" prop="roleName" width="170" sortable></el-table-column>
                            <el-table-column label="角色代码" prop="roleCode" width="170" sortable></el-table-column>
                            <el-table-column label="角色类型" prop="roleType" width="120" align="center" sortable>
                                <template slot-scope="scope">
                                    <el-tag size="small" :type="getRoleTypeTagType(scope.row.roleType)">{{scope.row.roleTypeName}}</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column label="角色描述" prop="description"></el-table-column>
                            <el-table-column label="创建时间" prop="createTime" width="100" align="center" sortable></el-table-column>
                            <el-table-column label="操作" width="140" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="openRoleViewConfigDialog('view', scope.row)">查看详情</el-button>
                                    <el-dropdown size="small" trigger="click" @command="handleRoleCommand(arguments[0], scope.row)">
                                        <span class="el-dropdown-link">
                                            <i class="el-icon-arrow-down el-icon--right"></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item command="view">查看详情</el-dropdown-item>
                                            <el-dropdown-item command="edit">修改角色</el-dropdown-item>
                                            <el-dropdown-item command="config">配置资源</el-dropdown-item>
                                            <el-dropdown-item command="delete" divided>删除角色</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="el-search-pager">
                        <el-pagination background v-show="showRoleQueryPager" @current-change="onRoleQueryCurrentPageChange" :current-page.sync="roleQueryForm.currentPage" :page-size="roleQueryForm.pageSize" layout="slot, prev, pager, next, total" :total="roleQueryTotal">
                            <div class="el-pagination-pagesize">
                                <span class="first">每页显示</span>
                                <el-button-group>
                                    <el-button :class="{active: roleQueryForm.pageSize == 10}" @click="onRoleQueryPageSizeChange(10);">10</el-button>
                                    <el-button :class="{active: roleQueryForm.pageSize == 20}" @click="onRoleQueryPageSizeChange(20);">20</el-button>
                                    <el-button :class="{active: roleQueryForm.pageSize == 50}" @click="onRoleQueryPageSizeChange(50);">50</el-button>
                                    <el-button :class="{active: roleQueryForm.pageSize == 100}" @click="onRoleQueryPageSizeChange(100);">100</el-button>
                                </el-button-group>
                                <span class="last">条</span>
                            </div>
                        </el-pagination>
                    </div>

                    <!-- 添加/修改Dialog -->
                    <el-drawer size="70%" :visible.sync="roleEditDialogVisible" @closed="closeRoleEditDialog">
                        <span slot="title" class="el-drawer-title"> {{roleEditDialogTitle}}</span>
                        <div class="el-drawer-content">
                            <el-form class="el-drawer-content-body" ref="roleEditForm" :model="roleEditForm" :rules="roleEditRules" label-width="120px">
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item label="角色名称" prop="roleName">
                                            <el-col :span="16">
                                                <el-input v-model="roleEditForm.roleName" :maxlength="50"></el-input>
                                            </el-col>
                                            <el-col :span="8">
                                                <p class="el-form-item-tips">2~50个汉字、字母、数字及下划线组成.</p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item label="角色代码" prop="roleCode">
                                            <el-col :span="16">
                                                <el-input v-model="roleEditForm.roleCode" :maxlength="50" :readonly="currentActionType == 'edit'"></el-input>
                                            </el-col>
                                            <el-col :span="8">
                                                <p class="el-form-item-tips">5~50个字母、数字、下划线组成.</p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item label="角色描述" prop="description">
                                            <el-col :span="16">
                                                <el-input type="textarea" v-model="roleEditForm.description" :maxlength="512"></el-input>
                                            </el-col>
                                            <el-col :span="8">
                                                <p class="el-form-item-tips"></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <div class="el-drawer-content-footer">
                                <el-button icon="fas fa-ban" @click="closeRoleEditDialog">取 消</el-button>
                                <el-button type="primary" icon="far fa-save" @click="saveRole" :loading="submiting">确 定</el-button>
                            </div>
                        </div>
                    </el-drawer>

                    <!-- 查看/配置Dialog -->
                    <el-drawer size="70%" :visible.sync="roleViewConfigDialogVisible" @closed="closeRoleViewConfigDialog">
                        <span slot="title" class="el-drawer-title"> {{roleViewConfigDialogTitle}}</span>
                        <div class="el-drawer-content">
                            <el-tabs class="el-drawer-content-body" v-model="roleViewConfigActiveTabName">
                                <el-tab-pane label="角色基本信息" name="roleDetail">
                                    <el-form class="el-form-detail" inline label-position="right" label-width="120px" label-suffix="：">
                                        <el-form-item label="角色ID">{{roleViewForm.roleId}}</el-form-item>
                                        <el-form-item label="角色名称">{{roleViewForm.roleName}}</el-form-item>

                                        <el-form-item label="角色代码">{{roleViewForm.roleCode}}</el-form-item>
                                        <el-form-item label="角色类型">{{roleViewForm.roleTypeName}}</el-form-item>

                                        <el-form-item label="角色描述" style="width:100%;">{{roleViewForm.description}}</el-form-item>

                                        <el-form-item label="创建时间">{{roleViewForm.createTime}}</el-form-item>
                                        <el-form-item label="修改时间">{{roleViewForm.updateTime}}</el-form-item>
                                    </el-form>
                                </el-tab-pane>
                                <el-tab-pane label="角色资源配置" name="roleResourceConfig">
                                    <div class="el-tree-role-resources-wrap" v-loading="roleResourcesLoading" element-loading-text="拼命加载中..." element-loading-class="el-loading-mask-opacity" :class="{loading: roleResourcesLoading}">
                                        <el-scrollbar class="el-scrollbar-resources" :wrap-style="resourcesScrollbarStyles">
                                            <el-tree ref="roleResourceViewTree" :data="roleResourceList" :props="defaultProps" node-key="id" :show-checkbox="true" :default-expand-all="true" :expand-on-click-node="true" :check-strictly="true" :render-content="renderRoleResourceTreeNode" @check="onRoleResourceTreeNodeCheckClick"></el-tree>
                                        </el-scrollbar>
                                    </div>
                                </el-tab-pane>
                            </el-tabs>
                            <div class="el-drawer-content-footer">
                                <el-button icon="fas fa-ban" @click="closeRoleViewConfigDialog">关 闭</el-button>
                                <el-button v-if="roleViewConfigActiveTabName == 'roleResourceConfig'" type="primary" icon="fas fa-sync-alt" @click="refreshRoleResourceConfig">刷新配置</el-button>
                                <el-button v-if="currentActionType == 'config' && roleViewConfigActiveTabName == 'roleResourceConfig'" type="primary" icon="far fa-save" @click="saveRoleResourceConfig" :loading="submiting">保存配置</el-button>
                            </div>
                        </div>
                    </el-drawer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { defaultApiErrorHandler, PLATFORM_API } from '@/api.js';
import { mapSort } from '@/utils.js';

const UPMS_ROLE_TYPE_SYSTEM = 0;

export default {
    name: 'UpmsRole',
    data() {
        return {
            submiting: false,
            roleList: [],
            roleQueryLoading: false,
            roleQuering: false,
            roleQueryForm: {
                roleName: '',
                roleCode: '',
                pageSize: 10,
                currentPage: 1
            },
            roleQueryTotal: 0,
            roleQuerySort: {
                prop: 'createTime',
                order: 'descending'
            },
            currentActionType: 'add',
            roleEditDialogVisible: false,
            roleViewConfigDialogVisible: false,
            roleViewConfigActiveTabName: 'roleDetail',
            roleEditForm: {
                roleId: '',
                roleName: '',
                roleCode: '',
                description: ''
            },
            roleEditRules: {
                roleName: [
                    {
                        required: true,
                        message: '请输入角色名称!'
                    },
                    {
                        pattern: /^[a-zA-Z\u00a1-\uffff0-9_]{2,50}$/,
                        message: '角色名称由2~50个汉字、字母、数字及下划线组成!'
                    }
                ],
                roleCode: [
                    {
                        required: true,
                        message: '请输入角色代码!'
                    },
                    {
                        pattern: /^\w{5,50}$/,
                        message: '角色代码由5~50个字母、数字、下划线组成!'
                    }
                ]
            },
            roleViewForm: {
                roleId: '',
                roleName: '',
                roleCode: '',
                roleType: '',
                roleTypeName: '',
                description: '',
                createBy: '',
                createTime: '',
                updateBy: '',
                updateTime: ''
            },
            roleResourceList: [],
            roleResourcesLoading: false,
            checkedResourceIdList: [],
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            resourcesScrollbarStyles: [
                {
                    maxHeight: '450px'
                }
            ]
        };
    },
    computed: {
        showRoleQueryPager() {
            if (this.roleQuering || this.roleQueryTotal == 0) {
                return false;
            } else {
                return true;
            }
        },
        roleEditDialogTitle() {
            if (this.currentActionType == 'add') {
                return '添加角色';
            } else if (this.currentActionType == 'edit') {
                return '修改角色';
            } else {
                return '';
            }
        },
        roleViewConfigDialogTitle() {
            if (this.currentActionType == 'view') {
                return '查看角色详情';
            } else if (this.currentActionType == 'config') {
                return '角色资源配置';
            } else {
                return '';
            }
        }
    },
    created() {},
    mounted() {
        this.queryRoleList(1000);
    },
    methods: {
        getRoleTypeTagType(roleType) {
            if (roleType == 0) {
                return 'success';
            } else {
                return 'primary';
            }
        },
        queryRoleList(loading) {
            this.roleQueryForm.currentPage = 1;
            this.doQueryRoleList(loading);
        },
        doQueryRoleList(loading) {
            this.roleQuering = true;
            if (loading) {
                this.roleQueryLoading = true;
            }
            setTimeout(() => {
                let params = Object.assign(
                    {},
                    this.roleQueryForm,
                    mapSort(this.roleQuerySort)
                );
                this.$http
                    .get(PLATFORM_API.of('/api/platform/upms/role/list'), {
                        params: params
                    })
                    .then(response => {
                        let result = response.data;
                        if (result.success) {
                            this.roleList = result.data;
                            this.roleQueryTotal = result.totalRowCount;
                        } else {
                            this.roleList = [];
                            this.roleQueryTotal = 0;
                            this.$message.error(result.message);
                        }
                    })
                    .catch(error => {
                        this.roleList = [];
                        this.roleQueryTotal = 0;
                        defaultApiErrorHandler.call(this, error);
                    })
                    .then(() => {
                        if (loading) {
                            this.roleQueryLoading = false;
                        }
                        this.roleQuering = false;
                    });
            }, loading);
        },
        resetRoleQueryForm() {
            this.$refs.roleQueryForm.resetFields();
        },
        onRoleQuerySortChange(parameter) {
            if (
                this.roleQuerySort.prop != parameter.prop ||
                this.roleQuerySort.order != parameter.order
            ) {
                this.roleQuerySort.prop = parameter.prop;
                this.roleQuerySort.order = parameter.order;
                this.queryRoleList(1000);
            }
        },
        onRoleQueryPageSizeChange(pageSize) {
            this.roleQueryForm.pageSize = pageSize;
            this.queryRoleList(1000);
        },
        onRoleQueryCurrentPageChange(currentPage) {
            this.roleQueryForm.currentPage = currentPage;
            this.doQueryRoleList(1000);
        },
        handleRoleCommand(cmd, row) {
            if (cmd == 'edit') {
                this.openRoleEditDialog(cmd, row);
            } else if (cmd == 'view') {
                this.openRoleViewConfigDialog(cmd, row);
            } else if (cmd == 'delete') {
                this.deleteRole(row);
            } else if (cmd == 'config') {
                this.openRoleViewConfigDialog(cmd, row);
            }
        },
        openRoleEditDialog(cmd, row) {
            this.currentActionType = cmd;
            this.roleEditDialogVisible = true;
            if (cmd == 'edit') {
                Vue.nextTick(() => {
                    Object.keys(this.roleEditForm).forEach(name => {
                        let value = row[name];
                        this.roleEditForm[name] = value;
                    });
                });
            }
        },
        closeRoleEditDialog() {
            this.submiting = false;
            this.roleEditDialogVisible = false;
            this.$refs.roleEditForm.resetFields();
            //手动reset
            this.roleEditForm.roleId = '';
        },
        openRoleViewConfigDialog(cmd, row) {
            this.currentActionType = cmd;
            this.roleViewConfigDialogVisible = true;
            Vue.nextTick(() => {
                Object.keys(this.roleViewForm).forEach(name => {
                    let value = row[name];
                    this.roleViewForm[name] = value;
                });
                if (cmd == 'config') {
                    this.roleViewConfigActiveTabName = 'roleResourceConfig';
                    Vue.nextTick(() => {
                        this.loadRoleResourceList(1500, row.roleId);
                    });
                } else {
                    this.roleViewConfigActiveTabName = 'roleDetail';
                    this.loadRoleResourceList(0, row.roleId);
                }
            });
        },
        closeRoleViewConfigDialog() {
            this.roleViewConfigDialogVisible = false;
            Object.keys(this.roleViewForm).forEach(name => {
                this.roleViewForm[name] = '';
            });
            this.roleResourceList = [];
            this.checkedResourceIdList = [];
        },
        deleteRole(row) {
            if (UPMS_ROLE_TYPE_SYSTEM == row.roleType) {
                this.$message.error('系统角色不能删除!');
            } else {
                let url = PLATFORM_API.of(
                    '/api/platform/upms/role/delete/' + row.roleId
                );
                this.$confirm('您确定要删除该角色?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http
                        .delete(url)
                        .then(response => {
                            let result = response.data;
                            if (result.success) {
                                this.$message.success(result.message);
                                this.queryRoleList(1000);
                            } else {
                                this.$message.error(result.message);
                            }
                        })
                        .catch(defaultApiErrorHandler);
                });
            }
        },
        saveRole() {
            let url = '';
            let method = 'post';
            if (this.currentActionType == 'add') {
                url = PLATFORM_API.of('/api/platform/upms/role/create');
                method = 'post';
            } else if (this.currentActionType == 'edit') {
                url = PLATFORM_API.of('/api/platform/upms/role/update');
                method = 'put';
            }
            if (url) {
                this.$refs.roleEditForm.validate(valid => {
                    if (valid && !this.submiting) {
                        this.submiting = true;
                        setTimeout(() => {
                            this.$http[method](url, this.roleEditForm)
                                .then(response => {
                                    let result = response.data;
                                    if (result.success) {
                                        this.closeRoleEditDialog();
                                        this.$message.success(result.message);
                                        this.queryRoleList(1000);
                                    } else {
                                        this.$message.error(result.message);
                                    }
                                })
                                .catch(defaultApiErrorHandler)
                                .then(() => {
                                    this.submiting = false;
                                });
                        }, 1500);
                    } else {
                        return false;
                    }
                });
            }
        },
        saveRoleResourceConfig() {
            let roleId = this.roleViewForm.roleId;
            let checkedKeys = this.$refs.roleResourceViewTree.getCheckedKeys();
            let checkedResourceIds = checkedKeys.sort().join(',');
            if (
                checkedResourceIds ==
                this.checkedResourceIdList.sort().join(',')
            ) {
                this.$message.warning('配置没有改变,无需保存!');
                return;
            } else {
                let url = PLATFORM_API.of(
                    '/api/platform/upms/role/resources/config'
                );
                if (!this.submiting) {
                    this.submiting = true;
                    setTimeout(() => {
                        this.$http
                            .post(url, {
                                roleId: roleId,
                                resourceIds: checkedResourceIds
                            })
                            .then(response => {
                                let result = response.data;
                                if (result.success) {
                                    this.$message.success(result.message);
                                    this.loadRoleResourceList(1500, roleId);
                                } else {
                                    this.$message.error(result.message);
                                }
                            })
                            .catch(defaultApiErrorHandler)
                            .then(() => {
                                this.submiting = false;
                            });
                    }, 1500);
                }
            }
        },
        refreshRoleResourceConfig() {
            let roleId = this.roleViewForm.roleId;
            this.loadRoleResourceList(1500, roleId);
        },
        loadRoleResourceList(loading, roleId) {
            let url = PLATFORM_API.of(
                '/api/platform/upms/role/resources/' + roleId
            );
            if (loading) {
                this.roleResourcesLoading = true;
            }
            setTimeout(() => {
                this.$http
                    .get(url)
                    .then(response => {
                        let result = response.data;
                        if (result.success) {
                            this.roleResourceList = result.data.allResourceList;
                            this.checkedResourceIdList =
                                result.data.checkedResourceIdList;
                            Vue.nextTick(() => {
                                this.$refs.roleResourceViewTree.setCheckedKeys(
                                    this.checkedResourceIdList
                                );
                            });
                        } else {
                            this.roleResourceList = [];
                            this.checkedResourceIdList = [];
                        }
                    })
                    .catch(error => {
                        this.roleResourceList = [];
                        this.checkedResourceIdList = [];
                        defaultApiErrorHandler.call(this, error);
                    })
                    .then(() => {
                        if (loading) {
                            this.roleResourcesLoading = false;
                        }
                    });
            }, loading);
        },
        renderRoleResourceTreeNode(h, param) {
            let _this = this;
            return h(
                'span',
                {
                    class: 'role-resource-custom-node el-clearfix'
                },
                [
                    h(
                        'span',
                        {
                            class:
                                'custom-label' +
                                (param.data.appRootResource
                                    ? ' custom-label-root'
                                    : '')
                        },
                        param.node.label
                    ),
                    h(
                        'div',
                        {
                            class: 'custom-action-type'
                        },
                        [
                            h(
                                'el-tag',
                                {
                                    props: {
                                        size: 'small',
                                        type: _this.getTagType4ActionType(
                                            param.data.actionType
                                        )
                                    }
                                },
                                param.data.actionTypeName
                            )
                        ]
                    )
                ]
            );
        },
        onRoleResourceTreeNodeCheckClick(data, state) {
            if (this.currentActionType == 'config') {
                let node = this.$refs.roleResourceViewTree.getNode(data);
                if (node.checked) {
                    this.recursiveCheckParent(node, true); //当前节点被选中时则选中其所有父节点
                } else {
                    this.recursiveCheckChild(node, false); //当前节点被取消选中时则取消选中其所有子节点
                }
            }
        },
        recursiveCheckParent(node, checked) {
            let parent = node.parent;
            if (parent) {
                parent.checked = checked;
                this.recursiveCheckParent(parent, checked);
            }
        },
        recursiveCheckChild(node, checked) {
            let childs = node.childNodes;
            if (childs.length) {
                childs.forEach(child => {
                    child.checked = checked;
                    this.recursiveCheckChild(child, checked);
                });
            }
        },
        getTagType4ActionType(actionType) {
            return actionType == 0 ? 'primary' : 'success';
        }
    }
};
</script>
<style lang='scss'>
.el-scrollbar-resources,
.el-scrollbar-resources > .el-scrollbar__wrap {
    overflow-x: hidden;
}
.el-tree-role-resources-wrap {
    min-height: 246px;
    overflow-x: hidden;
}
.el-tree-node__content {
    position: relative;
    height: auto;
    min-height: 34px;
    line-height: 34px;
}
.el-tree-node__content > .el-checkbox {
    vertical-align: top;
}
.role-resource-custom-node {
    display: inline-block;
    vertical-align: middle;
    white-space: normal;
    font-size: 14px;
    width: 100%;
    margin-left: -50px;
    padding-left: 50px;
    box-sizing: border-box;
}
.role-resource-custom-node > .custom-label {
    display: block;
    float: left;
    width: auto;
}
.role-resource-custom-node > .custom-label-root {
    font-weight: bold;
    color: $--color-primary;
}
.role-resource-custom-node > .custom-action-type {
    display: block;
    float: right;
    padding: 5px;
    box-sizing: border-box;
    line-height: 1;
    min-height: 30px;
    width: 160px;
    text-align: center;
}
.role-resource-custom-node > .custom-action-type > .el-tag--small {
    margin-top: 1px;
}
</style>